<template>
    <div style="height: 100%">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 40px">
            <p style="font-size: 17px; font-weight: bold">用户：{{ queryInfo.cust_name }}</p>
            <div>
                <!-- <el-button type="primary" size="mini" icon="el-icon-plus" @click="add" v-if="perData.allow_add == 1">{{ $t('common.add') }}</el-button> -->
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="!isedit"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isedit || !nullBtn"
                    @click="removeEvent"
                    v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button
                >
                <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-document-checked"
                    :disabled="isedit || !nullBtn"
                    @click="saveIt"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.save') }}</el-button
                >
                <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-refresh-left"
                    :disabled="isedit"
                    v-if="perData.allow_edit == 1"
                    @click="refreshData()"
                    >撤回</el-button
                >
                <el-dropdown @command="handleCommand" style="margin-left: 10px" trigger="click">
                    <el-button type="primary" :disabled="!isedit"> 更多<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">
                            <template>
                                <el-upload
                                    style="border: none"
                                    class="biaoge"
                                    action=""
                                    :on-change="handleChange"
                                    :show-file-list="false"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                                    :auto-upload="false"
                                >
                                    导入工费
                                </el-upload>
                            </template>
                        </el-dropdown-item>
                        <el-dropdown-item command="b">下载模板</el-dropdown-item>
                        <el-dropdown-item command="c">导出工费</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button type="primary" size="mini" icon="el-icon-printer" :disabled="isAdd||!isedit||nullBtn">{{ $t('common.print') }}</el-button> -->
            </div>
        </div>
        <!-- <div style="margin-bottom:10px;text-align:right;margin-top:50px;">
            <el-button type="primary" size="mini" icon="el-icon-plus" :disabled="isedit" @click="insertEvent(-1)">{{ $t('common.add') }}</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" :disabled="isedit" @click="removeEvent()">{{ $t('common.delete') }}</el-button>
        </div> -->
        <div class="table_warpper">
            <div class="table_head">
                <!-- <el-button type="primary" @click="add" :disabled="isedit">添加</el-button> -->
                <el-button type="primary" @click="ondiang()" :disabled="isedit">选择产品</el-button>

                <!-- <mySelect values="kind_no" labels="kind_name" keys="kind_no" class="myselect" /> -->
            </div>
            <vxe-table
                border
                stripe
                resizable
                keep-source
                align="center"
                ref="xTable1"
                height="600"
                show-overflow
                highlight-hover-row
                :loading="loading"
                :keyboard-config="{ isArrow: true, isEnter: true, isTab: true, isEdit: true }"
                :edit-rules="validRules"
                :data="tableData"
                :mouse-config="{ selected: true }"
                :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
            >
                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                <!-- <vxe-table-column  type="seq" field="seq"  width="50" title="序号"></vxe-table-column> -->
                <!-- <vxe-table-column field="cust_no" title="客户编号" width="100" :edit-render="{name: '$select' , options: allArr.counter, props: { clearable: true ,placeholder:'请输入',disabled: isedit},optionProps: {value: 'kind_no', label: 'kind_name'}}"></vxe-table-column> -->
                <!-- <vxe-table-column field="style_no" title="产品名称" width="120" :edit-render="{
          name: '$select',
          options: allArr.style,
          props: { clearable: true, placeholder: '请输入', disabled: true },
          optionProps: { value: 'style_no', label: 'style_name' },
          events: { change: selectChange }
        }"></vxe-table-column> -->
                <vxe-table-column field="style_no" width="120" title="产品ID"></vxe-table-column>
                <vxe-table-column field="style_name" width="120" title="产品名称"></vxe-table-column>
                <vxe-table-column title="入库">
                    <vxe-table-column
                        field="indiscount"
                        title="入库折扣"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="incontainloss_rate"
                        title="入库含耗率"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="inqty_prc"
                        title="入库数单价"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="inwgt_prc"
                        title="入库重工费"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="inadd_wgtwage"
                        title="入库附加工费(重)"
                        width="140"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="inadd_qtywage"
                        title="入库附加工费(数)"
                        width="140"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="inadd_wage"
                        title="入库附加工费"
                        width="140"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                </vxe-table-column>
                <vxe-table-column title="出库">
                    <vxe-table-column
                        field="salediscount"
                        title="出库折扣"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="salecontainloss_rate"
                        title="出库含耗率"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="saleqty_prc"
                        title="出库数单价"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="salewgt_prc"
                        title="出库重工费"
                        width="120"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="saleadd_wgtwage"
                        title="出库附加工费(重)"
                        width="140"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="saleadd_qtywage"
                        title="出库附加工费(数)"
                        width="140"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="saleadd_wage"
                        title="出库附加工费"
                        width="140"
                        :edit-render="{ name: 'input', attrs: { disabled: isedit, type: 'number' } }"
                    ></vxe-table-column>
                </vxe-table-column>
                <vxe-table-column field="remark" title="备注" min-width="300" :edit-render="{ name: 'input', attrs: { disabled: isedit } }">
                </vxe-table-column>
            </vxe-table>
        </div>
        <el-dialog title="选择产品" :visible.sync="ischoose" width="60%">
            <div class="choose_warpper">
                <div class="head">
                    <div class="left">
                        <mySelect
                            v-model="screenForm.gold_no"
                            :options="choosePull.gold"
                            values="kind_no"
                            placeholders="成色"
                            labels="kind_name"
                            keys="kind_no"
                            class="myselect"
                        />
                        <mySelect
                            v-model="screenForm.type_no"
                            :options="choosePull.type"
                            values="kind_no"
                            placeholders="品类"
                            labels="kind_name"
                            keys="kind_no"
                            class="myselect"
                        />
                        <mySelect
                            v-model="screenForm.kind_no"
                            :options="choosePull.kind"
                            values="kind_no"
                            placeholders="品目"
                            labels="kind_name"
                            keys="kind_no"
                            class="myselect"
                        />
                        <el-input v-model="screenForm.seek" :placeholder="$t('common.search')" style="width: 200px; margin-right: 10px"></el-input>
                        <el-button type="primary" @click="screenProduct()" style="margin-right: 60px">{{ $t('common.filter') }}</el-button>
                        <el-button type="primary" @click="chooseComfirm()" class="choose">选择</el-button>
                    </div>
                    <!-- <div class="right">
              <el-input placeholder="请输入内容" v-model="screenForm.seek" class="input-with-select">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div> -->
                </div>
                <el-table :data="productData" border @selection-change="chooseSelectionChange" max-height="470">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column label="产品编号" sortable prop="style_no"></el-table-column>
                    <el-table-column label="产品名称" prop="style_name"></el-table-column>
                    <el-table-column label="成色" sortable prop="gold_name"></el-table-column>
                    <el-table-column label="品类" sortable prop="type_name"></el-table-column>
                    <el-table-column label="品目" sortable prop="kind_name"></el-table-column>
                    <el-table-column :label="$t('common.remark')" prop="remark"></el-table-column>
                </el-table>
                <div class="choosepagination">
                    <el-button @click="ischoose = false">取 消</el-button>
                    <el-pagination
                        background
                        layout="total,sizes,prev, pager, next"
                        @current-change="handlePageChange"
                        @size-change="pageSizeChange"
                        :page-size="pageSize"
                        :current-page="page"
                        :total="choosetotal"
                    >
                    </el-pagination>
                </div>
            </div>
            <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="ischoose = false">取 消</el-button>
        <el-button type="primary" @click="chooseComfirm()">确 定</el-button>
      </div> -->
        </el-dialog>
    </div>
</template>

<script>
import {
    apiCurrentPermisson,
    apiWorkCust,
    apiWorkCustMody,
    apiWorkCustPull,
    apiSystem,
    custStyleLists,
    custStylePull,
    custwageImport,
    aCustWage
} from '@/request/api';
import store from '../../store/index';
// import $ from jquery
export default {
    // name:'custfee',
    data() {
        return {
            tableData: [],
            allArr: '',
            isedit: true,
            isAdd: false,
            loading: false,
            perData: '',
            validRules: {
                style_no: [{ required: true, message: '产品编号必须填写' }]
            },
            nullBtn: false,
            pull_code: [],
            systemSet: '',
            bigName: '',
            ischoose: false,
            productData: [],
            choosetotal: 0,
            page: 1,
            pageSize: 10,
            chooseProduct: [],
            choosePull: {},
            screenForm: {
                gold_no: '',
                type_no: '',
                kind_no: '',
                seek: ''
            },
            removalData: []
        };
    },
    created() {
        this.geData();
        this.getPermission();
        this.getSelectData();
        this.getSystem();
        this.bigName = this.$route.query.id.cust_name;
        this.getChooseData();
        this.getChoosePull();
    },
    computed: {
        queryInfo() {
            return store.state.Customerlaborcost;
        }
    },
    methods: {
        // 获取页面信息-----------------------------------------
        geData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            // this.isAdd = false;
            apiWorkCust({
                cust_no: this.queryInfo.cust_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data;
                    this.nullBtn = true;
                } else {
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.tableData = [];
                    }
                    this.$message.error(res.data.info);
                }
                loading.close();
            });
        },
        //下拉列表-----------------------------------------------------
        getSelectData() {
            apiWorkCustPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 选择产品列表
        getChooseData() {
            var table1 = this.$refs.xTable1.getTableData().fullData;

            // 提取当前表格中所有的 style_no
            const selectedStyleNos = table1
                .filter(item => item.style_no)
                .map(item => item.style_no);
            this.getChoosePull();
            custStyleLists({
                str: '',
                by: '',
                page: this.page,
                page_size: this.pageSize,
                cust_no: this.queryInfo.cust_no,
                style_nos: selectedStyleNos, // 传入提取的 style_no 数组
                ...this.screenForm
            }).then((res) => {
                this.productData = res.data.data;
                this.choosetotal = res.data.page_total;
            });
        },
        // 去重
        removal(type, status) {
            //
            let dtl = JSON.stringify(this.removalData);

            aCustWage({
                cust_no: this.queryInfo.cust_no,
                dtl: dtl,
                type: type,
                status: status
            }).then((res) => {
                this.removalData = [];
                this.getChooseData();
            });
        },
        ondiang() {
            this.getChooseData();
            this.ischoose = true;
        },
        // 获取产品是筛选下拉数据
        getChoosePull() {
            custStylePull({}).then((res) => {
                this.choosePull = res.data;
            });
        },
        // 筛选
        screenProduct() {
            this.getChooseData();
        },
        // 页码操作
        handlePageChange(val) {
            this.page = val;
            this.getChooseData();
        },
        pageSizeChange(val) {
            this.pageSize = val;
            this.getChooseData();
        },
        // 选择产品
        chooseSelectionChange(row) {
            let chooseProduct = [];
            let removalData = [];
            row.forEach((item, index) => {
                chooseProduct.push({});
                chooseProduct[index].style_no = row[index].style_no;
                removalData.push(row[index].style_no);
                chooseProduct[index].style_name = row[index].style_name;
            });
            this.chooseProduct = chooseProduct;
            this.removalData = removalData;
        },
        // 选择产品确认
        chooseComfirm() {
            this.ischoose = false;
            let chooseProduct = this.chooseProduct;
            if (chooseProduct.length > 0) {
                this.nullBtn = true;
            }
            chooseProduct.forEach((item) => {
                this.insertEvent(item, -1);
            });
            this.removal(true, '');
            // this.saveItC()
            // this.tableData=this.tableData.concat(this.chooseProduct)
        },
        handleCommand(command) {
            if (command == 'a') {
                // this.handleChange()
                // custwageImport({}).then(res=>{
                // })
            } else if (command == 'b') {
                //
                window.location = this.$baseURL + 'cust_mol_export';
            } else if (command == 'c') {
                window.location = this.$baseURL + 'cust_export?cust_no=' + this.queryInfo.cust_no;
            }
        },

        // 导入
        handleChange(file) {
            // return
            let data = new FormData(); //创建form对象
            data.append('file', file.raw);

            data.append('cust_no', this.queryInfo.cust_no);
            custwageImport(data).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.geData();
                } else {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i].error + '<br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                }
            });
        },
        // 自动填充客户名称
        selectChange(row, $event) {
            row = row.row;
            if (row) {
                var newArr = this.allArr.style.filter(function (obj) {
                    return obj.style_no == row.style_no;
                });
                if (row.style_no) {
                    row.style_name = newArr[0].style_name;
                }
            }
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.geData();
            this.removal('', true);
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            if (!this.queryInfo.cust_no) {
                this.$message.error('没有客户编号');
                return;
            }
            if (this.isedit == true) {
                this.isedit = false;
            }
        },
        // 保存修改------------------------------------------
        saveIt() {
            this.$load.show();
            var table1 = this.$refs.xTable1.getTableData().fullData;

            table1.forEach((item, index) => {
                delete item.style_name;
            });
            table1 = table1.filter((item) => item.style_no != '');

            //   table1['cust_no']=this.$route.query.id.cust_no
            apiWorkCustMody({
                data: table1,
                cust_no: this.queryInfo.cust_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success('修改成功'); //修改商品
                    this.tableData = res.data;
                    // this.geData()
                    this.isedit = true;
                    this.isAdd = false;
                    this.getChooseData();
                } else {
                    this.$message.error(res.data.info);
                }
                this.$load.close();
            });
        },

        //添加产品-----------------------------------
        add() {
            // this.isedit = false;
            // this.isAdd = true;
            this.insertEvent(null, -1);
            this.nullBtn = true;
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //插入新数据--------------------------------------------
        async insertEvent(row, index) {
            let record = {};
            if (row) {
                record = {
                    style_no: row.style_no,
                    style_name: row.style_name
                };
            } else {
                record = {
                    style_no: ''
                };
            }

            let { row: newRow } = await this.$refs.xTable1.insertAt(record, index);
            // await this.$refs.xTable1.setActiveCell(newRow, 'style_no');
        },

        //删除--------------------------------------------
        removeEvent() {
            let length = this.$refs.xTable1.getCheckboxRecords();
            let removalData = [];
            length.forEach((item) => {
                removalData.push(item.style_no);
            });

            if (length.length == 0) {
                this.$message.error('请选择你要删除的');
            } else {
                this.$XModal.confirm('您确定要删除该数据?').then((type) => {
                    if (type === 'confirm') {
                        this.$refs.xTable1.removeCheckboxRow();
                        this.removalData = removalData;
                        this.removal(false);
                        // this.saveIt();
                        //
                        // let tableLength=this.$refs.xTable1.getTableData()
                        //
                        // if((tableLength.tableData).length==0){
                        //   this.nullBtn=false
                        // }
                    }
                });
            }
        },
        //回车事件-----------------------------------------
        enterFilterEvent({ $panel, row }, event) {
            if (event.keyCode === 13) {
                this.insertEvent(-1);
            } else if (event.keyCode === 46) {
                this.$refs.xTable1.remove(row);
            }
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '67'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.myselect {
    width: 100px;
    margin-right: 10px;
}

.table_warpper {
    border: 1px solid #d1d3d4;
    padding: 8px;
    border-radius: 10px;
    background-color: #fff;
    height: 80%;

    .table_head {
        margin-bottom: 10px;
    }

    // .vxetable{
    //   height: 92%;
    // }
}

.choose_warpper {
    .head {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .left {
            width: 100%;
            display: flex;
            position: relative;
            .choose {
                position: absolute;
                right: 0px;
            }
        }
        .right {
            .input-with-select {
            }
        }
    }

    .choosepagination {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        width: 100%;
        // text-align: center;
    }
}
</style>
<style>
.vxe-table thead {
    background-color: #ecf5ff;
}

.vxe-table {
    background: #fff;
}

.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}

.el-select {
    width: 100%;
}

.my-dropdown1 {
    height: auto;
    max-height: 200px;
    width: auto;
    padding: 2px 5px;
    overflow: auto;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
}

.list-item1:hover {
    background-color: #f5f7fa;
}

.el-upload--text {
    background: none;
    width: auto;
    height: auto;
    font-size: 13px;
    color: #666;
    border: none;
    display: block;
}

.el-upload--text:hover {
    color: #66b1ff;
}
</style>
